import {Observable} from 'rxjs';
import {UserRoleCode} from '~shared/types/user.types';

export abstract class AuthenticationServiceBase {
    public isAuthorized$: Observable<boolean>;
}

export type BaseAuthForm = {
    basicAuthEmail: string,
    basicAuthPassword: string,
};

export type TwoFactorAuthForm = {
    authenticatorCode: string
}

export type MultipleAuthForm = BaseAuthForm | TwoFactorAuthForm;

export type StatusResponseSuccess = {
    loggedIn: true,
    permissions: Array<Permission>,
    roles: Array<UserRoleCode>,
    restricted: Array<string> | null,
    source: string
}

export type StatusResponseFailed = {
    loggedIn: false,
}

export type StatusResponse = StatusResponseSuccess | StatusResponseFailed;

export function isStatusResponseSuccess($: StatusResponse): $ is StatusResponseSuccess {
    return typeof $ === 'object'
        && $ !== null
        && $.hasOwnProperty('permissions');
}

export enum Permission {
    DASHBOARD = 'DASHBOARD',
    ALL_TRANSACTIONS = 'ALL_TRANSACTIONS',
    EXCHANGE_SERVICE = 'EXCHANGE_SERVICE',
    CRYPTO_SERVICE = 'CRYPTO_SERVICE',
    STATISTICS = 'STATISTICS',
    BALANCE = 'BALANCE',
    VIEW_USER = 'VIEW_USER',
    BANK_IN_OUT = 'BANK_IN_OUT',
    CRYPTO_OUT = 'CRYPTO_OUT',
    CLIENTS = 'CLIENTS',
    KYC = 'KYC',
    TICKETS = 'TICKETS',
    USERS = 'USERS',
    SETTINGS = 'SETTINGS',
    EDIT_ROLES = 'EDIT_ROLES',
    EDIT_EXCHANGE = 'EDIT_EXCHANGE',
    EDIT_CRYPTO = 'EDIT_CRYPTO',
    EDIT_USER = 'EDIT_USER',
    EDIT_SETTINGS = 'EDIT_SETTINGS',
    EDIT_BANK_TRANSACTION = 'EDIT_BANK_TRANSACTION',
    EDIT_CRYPTO_TRANSACTION = 'EDIT_CRYPTO_TRANSACTION',
    UPDATE_FUNDS = 'UPDATE_FUNDS',
    DATA_ACROSS_WHITE_LABELS = 'DATA_ACROSS_WHITE_LABELS',
    POOL = 'POOL'
}
